module.exports = __webpack_public_path__ + "img/measurement-rooms.dbc683e1.svg";